
import Partnership from "../components/Partnership.vue";
export default {
    components: {Partnership},
    head() {
        return {
            title: 'Сотрудничество',
            meta: [
                { hid: 'description', name: 'description', content: '' },
                { hid: 'keywords', name: 'keywords', content: '' },
            ]
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
}
